import { AccessTypeSelection } from '../../../common/enums/access-type-selection.enum';
import { GranteeIneligibleReasons } from '../../../common/enums/ineligible-scenarios.enum';
import { PERMISSION_REQUEST_ERRORS } from '../../enums/permission_request_error.enum';

export enum ErrorPage {
    TECH_DIFF,
    GRANTEE_CANT_COMPLETE_ONLINE,
    GRANTEE_PIN_EXPIRED,
    GRANTEE_TOO_MANY_ATTEMPTS,
    GRANTEE_HAS_PENDING_REQUEST,
    GRANTEE_FOREIGN_ADDRESS,
    GRANTEE_LINK_EXPIRED,
    GAF_PARTIAL_SUCCESS,
    GAF_SUBMIT_ALL_FAILED,
    ACCEPT_ACCESS_FLOW_PARTIAL_SUCCESS,
    ACCEPT_ACCESS_FLOW_SUBMIT_ALL_FAILED,
    RAF_PARTIAL_SUCCESS,
    RAF_SUBMIT_ALL_FAILED,
}

export interface ErrorPageData {
    successfulAccessRequestsInfo?: {
        accessLevel: AccessTypeSelection;
        accountNames: string[];
    };
    GAF_SUBMIT_ALL_FAILED?: never;
    RAF_SUBMIT_ALL_FAILED?: never;
    granteeName?: string;
}

export const errorPageMap: Partial<Record<PERMISSION_REQUEST_ERRORS, ErrorPage>> = {
    [PERMISSION_REQUEST_ERRORS.RECORD_NOT_FOUND]: ErrorPage.TECH_DIFF,
    [PERMISSION_REQUEST_ERRORS.RECORD_EXPIRED]: ErrorPage.GRANTEE_PIN_EXPIRED,
    [PERMISSION_REQUEST_ERRORS.TOO_MANY_ATTEMPTS]: ErrorPage.GRANTEE_TOO_MANY_ATTEMPTS,
    [PERMISSION_REQUEST_ERRORS.ALREADY_HAS_ACCESS]: ErrorPage.GRANTEE_LINK_EXPIRED,
};

export const granteeIneligibleReasonPageMap: Partial<Record<GranteeIneligibleReasons, ErrorPage>> = {
    [GranteeIneligibleReasons.FOREIGN_ADDRESS]: ErrorPage.GRANTEE_FOREIGN_ADDRESS,
    [GranteeIneligibleReasons.ASSOCIATED_OR_CONTROL_PERSON]: ErrorPage.GRANTEE_CANT_COMPLETE_ONLINE,
};
